// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"560b2fd7","487":"8c435e47","578":"a0376dab"}[chunkId] + ".chunk.js";
};